import request from '@/utils/request'



//周测列表
export function weeklyTestListAPI (data) {
    return request({
      url: `/weeklyTest/list`,
      method: 'POST',
      data,
    })
  }



//   添加周测
export function addWeeklyTestListAPI (data) {
    return request({
      url: `/weeklyTest/add`,
      method: 'POST',
      data,
    })
  }



//   查看周测详情
export function getOneWeeklyTesttAPI (id) {
    return request({
      url: `/weeklyTest/getOne/${id}`,
      method: 'get',
    })
  }

  //修改周测信息
  export function updateEeeklyTestAPI (data) {
    return request({
      url: `/weeklyTest/update`,
      method: 'put',
      data
    })
  }

//   查看周测次数
export function getWeeklyTestlistCountAPI (data) {
    return request({
      url: `weeklyTest/listCount`,
      method: 'POST',
      data,
    })
  }

  

  // 查看周测规则
  export function weeklyTestScoreRulesListAPI (data) {
    return request({
      url: `/weeklyTestScoreRules/list`,
      method: 'POST',
      data,
    })
  }



  // 添加周测规则
  export function addWeeklyTestScoreRulesListAPI (data) {
    return request({
      url: `/weeklyTestScoreRules/add`,
      method: 'POST',
      data,
    })
  }



  //修改周测规则
  export function updateWeeklyTestScoreRulesListAPI (data) {
  return request({
    url: `/weeklyTestScoreRules/update`,
    method: 'PUT',
    data,
  })
}


// WEBPACK FOOTER //
// ./src/api/weeklyTest.js